import { CustomerOrderContextMenuComponentsProps } from "src/tenantCustomizations/TenantCustomizations.ts";
import { AsyncMenuButton } from "src/components/common/contextMenu/AsyncMenuButton.tsx";
import { faTag } from "@fortawesome/pro-regular-svg-icons";
import i18n from "i18next";
import { downloadFile } from "src/utils/fileDownloading.ts";
import { SirmetCustomerOrderApi } from "src/api/generated/tenants/sirmet/sales/sirmetCustomerOrderApi.ts";

export const SirmetCustomerOrderContextMenuComponents = ({
	onlySingleRowSelected,
	row,
}: CustomerOrderContextMenuComponentsProps) => {
	return [
		onlySingleRowSelected && (
			<AsyncMenuButton
				key={"printShopOrderLabels"}
				icon={faTag}
				label={i18n.t("print_labels")}
				onClick={async () => {
					const fileHandle = await SirmetCustomerOrderApi.printShopOrderLabelsForCustomerOrder({
						customerOrderId: row.customerOrderId,
					});
					downloadFile(fileHandle);
				}}
			/>
		),
	];
};
